(function () {
    'use strict';
  
    // ─── Helpers ────────────────────────────────────────────────────────────────
  
    function formatMoney(cents) {
        return (cents / 100).toLocaleString('en-US', {
            style:    'currency',
            currency: window.Shopify?.currency?.active || 'USD'
        });
    }
  
    function isSaleInWindow(sale) {
        if (!sale || !sale.value) return false;

        const tz  = window.STORE_DISCOUNTS?.tzOffset || '+00:00';
        const now = Date.now();

        if (sale.startDate) {
            const start = new Date(`${sale.startDate}T${sale.startTime || '00:00'}:00${tz}`).getTime();
            if (now < start) return false;
        }

        if (sale.endDate) {
            const end = new Date(`${sale.endDate}T${sale.endTime || '23:59'}:00${tz}`).getTime();
            if (now > end) return false;
        }

        return true;
    }

    function getDiscount(group) {
        const d = window.STORE_DISCOUNTS;
        if (!d) return null;

        const groupData = d[group];
        if (!groupData) return null;

        // Sale discount takes priority if within its scheduled window
        if (isSaleInWindow(groupData.sale)) {
            return { type: 'percentage', value: groupData.sale.value };
        }

        // Fall back to non-sale discount (active when value > 0)
        return groupData.value > 0 ? { type: 'percentage', value: groupData.value } : null;
    }
  
    function calculateSavings(priceCents, discount) {
        if (discount.type === 'percentage') {
            return Math.round(priceCents * (discount.value / 100));
        }
        // Fixed amount — value stored in cents
        return discount.value;
    }
  
    // ─── Core: apply UI to a single discount-target element ─────────────────────
  
    function applyDiscountUI(el) {
        const group     = el.dataset.discountGroup;
        const price     = parseInt(el.dataset.price, 10);
        const discount  = getDiscount(group);

        const badge         = el.querySelector('.mp-discount-badge');
        const pricesWrapper = el.querySelector('.mp-discounts-prices');
        const originalPrice = el.querySelector('.mp-discount-original-price');
        const salePrice     = el.querySelector('.mp-discount-sale-price');
        const savings       = el.querySelector('.mp-discount-savings');

        if (!discount) {
            el.style.display = 'none';
            if (pricesWrapper) pricesWrapper.classList.remove('mp-discounts-active');
            return;
        }

        el.style.display = 'flex';
  
        const savingsAmount   = calculateSavings(price, discount);
        const discountedPrice = price - savingsAmount;
    
        if (badge) {
            badge.textContent   = 'Save ' + discount.value + '%';
            badge.style.display = 'inline-block';
            badge.classList.add('mp-discounts-active');
        }
    
        if (pricesWrapper) {
            pricesWrapper.classList.add('mp-discounts-active');
        }

        if (originalPrice) {
            originalPrice.textContent   = formatMoney(price);
            originalPrice.style.display = 'flex';
        }
    
        if (salePrice) {
            salePrice.textContent   = formatMoney(discountedPrice);
            salePrice.style.display = 'flex';
        }
    
        if (savings) {
            savings.textContent   = 'You save ' + formatMoney(savingsAmount);
            savings.style.display = 'inline-block';
        }
    }
  
    // ─── Apply to all targets on the page ───────────────────────────────────────
  
    function applyAll() {
        document
            .querySelectorAll('.discount-target')
            .forEach(applyDiscountUI);

        syncOriginalPriceVisibility();
    }

    // ─── Sync theme element visibility based on active discount UI ──────────────

    function syncOriginalPriceVisibility() {
        // Prices
        document.querySelectorAll('.mp-discounts-prices.mp-discounts-active').forEach(wrapper => {
            const sibling = wrapper.closest('.discount-target')?.parentElement?.querySelector('.price-theme-original');
            if (sibling) sibling.classList.add('hidden');
        });
        document.querySelectorAll('.mp-discounts-prices:not(.mp-discounts-active)').forEach(wrapper => {
            const sibling = wrapper.closest('.discount-target')?.parentElement?.querySelector('.price-theme-original');
            if (sibling) sibling.classList.remove('hidden');
        });

        // Badges
        document.querySelectorAll('.mp-discount-badge.mp-discounts-active').forEach(badge => {
            const sibling = badge.closest('.discount-target')?.parentElement?.querySelector('.badges-theme-original');
            if (sibling) sibling.classList.add('hidden');
        });
        document.querySelectorAll('.mp-discount-badge:not(.mp-discounts-active)').forEach(badge => {
            const sibling = badge.closest('.discount-target')?.parentElement?.querySelector('.badges-theme-original');
            if (sibling) sibling.classList.remove('hidden');
        });
    }
  
    // ─── Cart: update line item display ─────────────────────────────────────────
  
    function applyCartDiscounts() {
        fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
            cart.items.forEach(item => {
            // Match cart line items by product id
            const el = document.querySelector(
                `.discount-target[data-product-id="${item.product_id}"]`
            );
            if (el) {
                // Override price from live cart data (most accurate)
                el.dataset.price = item.original_price;
                applyDiscountUI(el);
            }
            });
        });
    }
  
    // ─── Init ───────────────────────────────────────────────────────────────────
  
    function init() {
        applyAll();
    
        // If cart elements exist on the page, also sync from cart API
        if (document.querySelector('[data-cart-item]')) {
            applyCartDiscounts();
        }
    
        // Re-run after dynamic section renders (theme editor, infinite scroll)
        document.addEventListener('shopify:section:load', applyAll);
    
        // Re-run after cart updates (for themes with dynamic cart drawers)
        document.addEventListener('cart:updated', applyAll);

        // Re-run when megamenu tabs-element injects product cards into the DOM
        new MutationObserver(mutations => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType !== 1) continue;
                    if (node.classList?.contains('discount-target') || node.querySelector?.('.discount-target')) {
                        applyAll();
                        return;
                    }
                }
            }
        }).observe(document.body, { childList: true, subtree: true });
    }
  
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
  
  })();